import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box, FormControlLabel, Tooltip } from '@mui/material';

// Styled switch for the toggle button - simple design
const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 20,
    height: 20,
    borderRadius: 10,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 12,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#E9E9EA',
    boxSizing: 'border-box',
  },
}));

interface ViewModeSwitchProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ViewModeSwitch: React.FC<ViewModeSwitchProps> = ({ checked, onChange }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 1.5,
      padding: '2px',
      borderRadius: '16px',
    }}>
      <MusicNoteIcon 
        color={checked ? 'disabled' : 'secondary'} 
        fontSize="small"
        sx={{ 
          opacity: checked ? 0.5 : 1,
          transition: 'opacity 0.2s',
        }}
      />
      <Tooltip title={`Switch to ${checked ? 'Music' : 'Video'} Player`}>
        <FormControlLabel
          control={
            <StyledSwitch
              checked={checked}
              onChange={onChange}
              inputProps={{ 'aria-label': 'toggle between music and video view' }}
            />
          }
          label=""
          sx={{ m: 0 }}
        />
      </Tooltip>
      <VideocamIcon 
        color={checked ? 'primary' : 'disabled'}
        fontSize="small"
        sx={{ 
          opacity: checked ? 1 : 0.5,
          transition: 'opacity 0.2s',
        }}
      />
    </Box>
  );
};

export default ViewModeSwitch;
